
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snorapport",
      function () {
        return require("private-next-pages/snorapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snorapport"])
      });
    }
  